import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public curStep = 1;
  public submitedStep = [false, false, false, false];

  isLoading = false;

  constructor() { }
}
